var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("vSelect", {
    staticClass: "dropdown form-control",
    attrs: {
      id: _vm.schema.id,
      placeholder: _vm.schema.placeholder,
      options:
        typeof _vm.schema.values === "function"
          ? _vm.schema.values(_vm.model)
          : _vm.schema.values,
      reduce: (option) => option.value,
      label: "name",
    },
    model: {
      value: _vm.value,
      callback: function ($$v) {
        _vm.value = $$v
      },
      expression: "value",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }